import React from "react";
import { Accordion, Card } from "react-bootstrap";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { Link } from "react-router-dom";

import type { TrocaPageHeader } from "features/troca-titularidade/types";

import AccordionHeaderToggle from "./AccordionHeaderToggle";
import {
  AccordionContainer,
  AccordionSection,
  BackButton,
  HeaderContainer,
} from "./TrocaTitularidadeAccordion.styles";

type TrocaTitularidadeAccordionProps = {
  header: TrocaPageHeader;
  defaultActiveKey: string;
};

const TrocaTitularidadeAccordion = ({
  header,
  defaultActiveKey,
}: TrocaTitularidadeAccordionProps): JSX.Element => {
  return (
    <AccordionSection>
      <BackButton to={{ pathname: "/" }}>
        <AiOutlineArrowLeft /> Voltar
      </BackButton>

      <HeaderContainer>
        <h1>{header.h1}</h1>
        <h2
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: header.h2 }}
        />
      </HeaderContainer>
      <AccordionContainer>
        <Accordion defaultActiveKey={defaultActiveKey}>
          <Card>
            <AccordionHeaderToggle eventKey="1" callback={() => null}>
              <span>Estou saindo do imóvel</span>
            </AccordionHeaderToggle>
            <Accordion.Collapse eventKey="1">
              <Card.Body>
                <p>
                  Ao sair do imóvel é preciso que solicite o{" "}
                  <b>desligamento do gás</b> ou que o novo morador da unidade
                  faça o <b>primeiro acesso</b> ao Portal Minha Ultragaz.
                </p>
                <p>
                  Para solicitar o desligamento do seu gás{" "}
                  <Link to="/">acesse o Portal Minha Ultragaz</Link> e clique em
                  &quot;desligar gás&quot;.
                </p>
                <p>
                  Para realizar o primeiro acesso no Portal Minha Ultragaz{" "}
                  <Link to="/primeiro-acesso-mi">clique aqui</Link>.
                </p>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <AccordionHeaderToggle eventKey="2" callback={() => null}>
              <span>Estou chegando no imóvel</span>
            </AccordionHeaderToggle>
            <Accordion.Collapse eventKey="2">
              <Card.Body>
                <p>
                  Para colocar a fatura do seu imóvel em seu nome é preciso
                  realizar o{" "}
                  <Link to="/primeiro-acesso-mi">primeiro acesso</Link> ao
                  Portal Minha Ultragaz.
                </p>
                <p>
                  Se você possui cadastro em nosso portal,{" "}
                  <Link to="/">faça o login</Link> e acesse &quot;adicionar nova
                  unidade&quot; no menu lateral esquerdo, siga os passos e
                  pronto!
                </p>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <AccordionHeaderToggle eventKey="3" callback={() => null}>
              <span>Quero solicitar Ligue ou Religue do meu gás</span>
            </AccordionHeaderToggle>
            <Accordion.Collapse eventKey="3">
              <Card.Body>
                <span>
                  <b>Ligue de fornecimento:</b>
                </span>
                <p>
                  Se você é o <b>novo morador do apartamento ou loja</b> o{" "}
                  <b>ligue</b> ocorre logo após realizar o{" "}
                  <Link to="/primeiro-acesso-mi">primeiro acesso</Link> ao
                  portal. A ligação de fornecimento da unidade será solicitado
                  automaticamente e ocorrerá em até 3 dias úteis.
                </p>
                <p>
                  Se você <b>já possui acesso ao Portal Minha Ultragaz</b> para
                  realizar o ligue de uma nova unidade que ainda não está em seu
                  nome{" "}
                  <Link to="/adicionar-unidade">Adicione nova unidade</Link> e o{" "}
                  <b>ligue</b> será solicitado automaticamente.
                </p>
                <p>
                  Para retomar uma unidade que já esteve em seu nome por favor,
                  entre em contato com o atendimento:
                </p>
                <p>
                  Regiões Metropolitanas: 4003-1616 Demais regiões:
                  0800-886-1616
                </p>
                <span>
                  <b>Religue de fornecimento:</b>
                </span>
                <p>
                  Quando deseja ligar a unidade que teve &quot;Bloqueio de
                  fornecimento por inadimplência&quot; ou solicitado o
                  &quot;Bloqueio de fornecimento temporário&quot;. Faça seu
                  acesso ao Portal Minha Ultragaz, clique em &quot;Ligar e
                  desligar gás&quot; e em &quot;Solicitar religue de
                  fornecimento&quot; leia as instruções e solicite seu religue.
                </p>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      </AccordionContainer>
    </AccordionSection>
  );
};

export default TrocaTitularidadeAccordion;
